export const PROJECTS_NAVIGATION_ID = {
  idProjects: 'id_Projects',
  idShared: 'id_Shared',
  idFavourites: 'id_Favourites',
  idArchive: 'id_Archive',
};
